module.exports = __webpack_public_path__ + "assets/task-reminder.svg";